import DownloadButtonBox from './DownloadButtonBox';
export default DownloadButtonBox;
//# sourceMappingURL=index.js.map